import PublicAPI from "./api";

export const FreteAPI = {
    findShip: async (dados) => {
        return await PublicAPI.post('/mostrar-fretes', dados);
    }
}